import React from 'react'
import styles from './LocationFeatures.module.scss'
import PropTypes from 'prop-types'
import LocationCategory from '../LocationCategory/LocationCategory'

const LocationFeatures = ({ certifications }) => {
    return (
        <div className={styles.content}>
            {certifications.map((cert, i) => {
                return <LocationCategory title={cert[0]?.parentCategoryDisplayName} category={cert} key={i} />
            })}
        </div>
    )
}

LocationFeatures.propTypes = {
    certifications: PropTypes.array,
    handleClose: PropTypes.func,
    handleGoBack: PropTypes.func,
}

export default LocationFeatures
